import nanToNull from "../../../functions/adapters/universal/nanToNull"
import { getDataUser } from "../../../functions/agent/agentModuleComponent/getDataUser"
import { checkIsHaveReraAndExpires } from "../../../functions/agent/documents/checkIsHaveDocumentsAndExpires"
import { getErrorss, getMessageForError } from "../../../functions/errors/GetErrors"
import { getQueryUnits } from "../../../functions/shared/api/queries/getQueryUnits"
import { sendCustomNotification } from "../../../functions/shared/notifications/sendCustomNotification"
import { ACCESS_KEY, REACT_APP_BSO_SUPPORT_USER_ID, URL_MAIN_API_APP, urlAPI, USER_ID_KEY } from "../../../urls"
import { dataFetchingFinish, dataFetchingStart } from "../../slices/modalSlice"
import { setMyArchivedUnitsOpen, setMyRequestedUnitsOpen } from "../../slices/unitsSlice"
import { type AppDispatch, type RootState } from "../../store"
import { singleUnitFetchingSuccess } from "../unitsActions"
import { fetchUser } from "../userActions"
import { deleteData } from "../userActions/deleteUserAction"
import { fetchUnits } from "./fetchUnits"


interface Response {
    success : boolean;
    response : {

   
        Code: number
        Response: {
            AuthorityNameAr: string
            AuthorityNameEn: string
            PermitNumber: string
            StartDate: Date
            EndDate: Date
            PermitEndDate: Date
            ListingNumber: string
            PermitStatusId: number
            PermitTypeId: number
            PermitStatusAr: string
            PermitStatusEn: string
            PermitDescription: null
            RealEstateNumber: string
            PermitLocation: null
            ListingStatus: null
            ListingFlag: null
            PropertyNumber: null
            PropertyTypeId: number
            PropertyNameAr: string
            PropertyNameEn: string
            ZoneNameAr: string
            ZoneNameEn: string
            PropertyTypeNameAr: string
            PropertyTypeNameEn: string
            PropertyDescription: null
            PropertyValue: number
            PropertyValueFrom: number
            PropertyValueTo: number
            PermitTypeNameAr: string
            PermitTypeNameEn: string
            FloorNumber: null
            RoomsCount: string
            ParkingNumber: null
            PropertySize: number
            ProjectNumber: null
            ProjectNameAr: null
            ProjectNameEn: null
            DeveloperNameAr: null
            DeveloperNameEn: null
            ProjectDescription: null
            ProjectValueFrom: null
            ProjectValueTo: null
            RoomTypeAr: string
            RoomTypeEn: string
            BuildingNameAr: string
            BuildingNameEn: string
            IsActive: boolean
            LicenseNumber: string
            PropertyId: number
            ProjectId: null
            RowState: number
            CardHolderNumber: string
            CardHolderNameAr: string
            CardHolderNameEn: string
            CardHolderMobile: string
            CardHolderEmail: string
            ListingGuid: string
            BuildingCount: null
            IsPermitBlocked: boolean
        }
        TimeStamp: Date
        Errors: Array<{
            Id: null
            RowKey: null
            ErrorNumber: number
            ErrorId: null
            ErrorMessage: null
            ErrorMessageAr: string
            ErrorMessageEn: string
            ErrorType: number
            ErrorKey: number
            ActionUrl: null
            ManualBusinessValidationResponse: null
        }>
        ExceptionId: null
        ActionUserId: null
        OtpCode: null
        TotalRowsCount: number
        IsUpdatebale: boolean
        Object: null
    }
}


export const getUnitDetailsByTrakheese = (bodyClient: {trakheese : string} )  => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? ''
   
    return async (dispatch: AppDispatch, getState: () => RootState) => {



        try {
       
            dispatch(dataFetchingStart())
            const responseReq  = await fetch(`${URL_MAIN_API_APP}/trakheesiVerification`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwt}`
                },
                body: JSON.stringify({ link: bodyClient?.trakheese })
            })
            const data : Response  = await responseReq.json() 
     
            if (data.success) {
                if (data?.response?.Errors?.length > 0) {
                    dispatch(dataFetchingFinish())
                    return { ...data, textNavigate: '', isSuccessful: false, textNotification: getErrorss(data) }
                } else {
                    const documents = getState().documents?.documents?.filter(doc => doc.attributes?.User?.data?.id === Number(userID))
                    const resMethodTrakh = data.response.Response  
                    const reraCardDoc = checkIsHaveReraAndExpires(documents).file
                    const reraExp = checkIsHaveReraAndExpires(documents).expireFile
        
                    // if(!(resMethodTrakh?.RealEstateNumber === reraCardDoc?.attributes?.Type?.[0]?.Number)){
                    //     dispatch(dataFetchingFinish())
                    //     return {  textNavigate: '', isSuccessful: false, textNotification: `You dont have permit to publish this unit.Your <strong>RERA has unmatched</strong>` }
                    // }


                    dispatch(dataFetchingFinish())
      
                    const propertyReq = {
                        name : resMethodTrakh.PropertyNameEn ?? resMethodTrakh.BuildingNameAr ?? resMethodTrakh.ZoneNameEn ?? resMethodTrakh.PermitTypeNameEn,
                        area : resMethodTrakh.ZoneNameEn ,
                        type: resMethodTrakh.PropertyTypeNameEn
                    }
                    //   

                    const response = await fetch(`${urlAPI}`, {
                        method: 'POST',
                        body: JSON.stringify({
                            method: 'POST',
                            collection: 'properties',
                            body: {
                                RefID: [propertyReq?.name, propertyReq?.area, new Date().getTime()]?.join(' <-> '),
                                Name: propertyReq?.name ,
                                Type: propertyReq?.type === "Villa" || propertyReq?.type === "Land" ? 'Community' : 'Building',
                                ManagedBy: Number(userID),
                                ...(propertyReq?.type === "Villa" ? { Community: propertyReq?.name } : {}),
                                ...(((getState()?.app?.config?.all?.Area?.includes(propertyReq?.area)) ?? false) ? 
                                    {Area:  propertyReq?.area } : { Area: null }),
                            }
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${jwt}`
                        }
                    })

                    const dataPropertyJSON = await response.json()
                    if (dataPropertyJSON.success === true) {
                        if (dataPropertyJSON.response.error != null) {
                            return { ...dataPropertyJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataPropertyJSON) }
                        } else {
                  
                            const response = await fetch(`${urlAPI}`, {
                                method: 'POST',
                                body: JSON.stringify({
                                    method: 'POST',
                                    collection: 'units',
                                    body: {
                                        RefID: [propertyReq?.name , propertyReq?.area, new Date().getTime()]?.join(' <-> '),
                                        User: Number(userID),
                                        Property :  dataPropertyJSON?.response?.data?.id ,
                                        Marketing : {
                                            Headline :  resMethodTrakh.BuildingNameEn ?? resMethodTrakh.PropertyDescription ?? resMethodTrakh.ZoneNameEn ?? resMethodTrakh.PropertyNameEn ?? resMethodTrakh.PropertyTypeNameEn  ?? "",
                                            Description : resMethodTrakh.PropertyDescription ?? "",
                                            Price : nanToNull(resMethodTrakh.PropertyValue),
                                            Use : resMethodTrakh.PermitTypeNameEn ===  "Rent" ? "For rent" : "For sale"   ,
                                            ManagedBy : 'Agent'
                                        },
                                        //      Number: String(propertyTitleDeed?.number),
                                        Statuses: ['Drafted'], // Registered 'Drafted' , "Door close"
                                        SizeArea: nanToNull(resMethodTrakh.PropertySize),
                                        Bedrooms : nanToNull(resMethodTrakh.RoomsCount), 
                                        RERANumber : resMethodTrakh.RealEstateNumber  ,
                                        PermitNumber : resMethodTrakh.PermitNumber,
                                        PermitLink : bodyClient?.trakheese
                                    },
                                    query: getQueryUnits()
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${jwt}`
                                }
                            })

                            const dataUnitJSON = await response?.json() as unknown as any
                            if (dataUnitJSON.success === true) {
                                if (dataUnitJSON.response.error != null) {
                                    await deleteData('properties',dataPropertyJSON?.response?.data?.id)
                                    dispatch(dataFetchingFinish())
                                    return { ...dataUnitJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataUnitJSON) }
                                } else {
                                    const { isSuccessful } = dispatch(singleUnitFetchingSuccess(dataUnitJSON))
                                    const { nameUser, nameAddress } = getDataUser(Number(userID) , dataPropertyJSON?.response?.data?.id)
                                    void sendCustomNotification(REACT_APP_BSO_SUPPORT_USER_ID ?? 0,
                                        'Check new requested unit, URGENT! ',
                                        `${nameUser}, requested unit - ${nameAddress}.`,
                                        `/landlord/my_units`)
                                    // dispatch(setMyRequestedUnitsOpen(true))
                                    if (!isSuccessful) {
                                        void dispatch(fetchUser(true))
                                        void dispatch(fetchUnits(true))
                                    }
                                    dispatch(dataFetchingFinish())
                                    return {
                                        ...dataUnitJSON,
                                        
                                        textNavigate: `/agent/modal/save_after_draft_agent_unit/${dataUnitJSON?.response?.data?.id}/${dataPropertyJSON?.response?.data?.id}`,  
                                        isSuccessful: true,
                                        //  textNavigate:   `/agent/my_units` ,
                                        // textNotification: "The unit creation request has been submitted. Upon approval, you will receive a version for publication."  ,
                                        textNotification:'Unit permit was successfully found, now you can check and add additional information and publish to catalog',
                                        title: 'Success'
                                    }                           
                                }
                            } else {
                                dispatch(dataFetchingFinish())
                                return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(getMessageForError('Some error! Please , try again'))}
                            }
                        }
                    } else {
                        dispatch(dataFetchingFinish())
                        return { textNavigate: '', isSuccessful: false, textNotification:  getErrorss(getMessageForError('Some error! Please , try again')) }
                    }

                }
            } else {
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: '' }
            }

        } catch (e) {
            dispatch(dataFetchingFinish())
            console.log(e)
        }
    }
}
